<template>
    <div class="sticky z-40 top-0 inset-x-0 bg-white">
        <div class="flex items-center justify-between border-b-2 border-gray-100 py-6">
            <nav class="hidden md:flex items-baseline lg:space-x-10 md:space-x-7 ml-8">
                <router-link
                    to="/"
                    class="font-medium text-base text-gray-500 hover:text-gray-900"
                    active-class="text-2xl text-gray-900"
                    exact
                >
                    <span v-if="isGerman">Projekte</span>
                    <span v-else>Project</span>
                </router-link>
                <router-link
                    to="/curriculum-vitae"
                    class="font-medium text-base text-gray-500 hover:text-gray-900"
                    active-class="text-2xl text-gray-900"
                    exact
                >
                    <span v-if="isGerman">Lebenslauf</span>
                    <span v-else>CV</span>
                </router-link>
                <router-link
                    to="/imprint"
                    class="font-medium text-base text-gray-500 hover:text-gray-900"
                    active-class="text-2xl text-gray-900"
                    exact
                >
                    <span v-if="isGerman">Impressum</span>
                    <span v-else>Imprint</span>
                </router-link>
                <router-link
                    to="/privacy"
                    class="font-medium text-base text-gray-500 hover:text-gray-900"
                    active-class="text-2xl text-gray-900"
                    exact
                >
                    <span v-if="isGerman">Datenschutz</span>
                    <span v-else>Privacy</span>
                </router-link>
                <router-link
                    to="/contact"
                    class="font-medium text-base text-gray-500 hover:text-gray-900"
                    active-class="text-2xl text-gray-900"
                    exact
                >
                    <span v-if="isGerman">Kontakt</span>
                    <span v-else>Contact</span>
                </router-link>
            </nav>
            <nav class="flex md:hidden ml-5 justify-start items-center">
                <div
                    @click="showSidebar = true"
                    class="flex justify-start md:ml-5"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 text-gray-500 hover:text-gray-900 cursor-pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </div>
                <div class="text-lg text-gray-500 font-semibold ml-5">
                    <span v-if="isGerman">Projekte</span>
                    <span v-else>Projects</span>
                </div>
            </nav>
            <div class="md:block hidden mr-8">
                <button
                    v-on:click="$emit('toggleLanguage')"
                    type="button"
                    class="bg-transparent hover:bg-purple-500 text-purple-700 hover:text-gray-50 border border-purple-500 hover:border-transparent px-4 py-2 rounded-md text-sm lg:text-base font-medium "
                >
                    <span v-if="isGerman">English</span>
                    <span v-else>Deutsch</span>
                </button>
            </div>
        </div>

        <!-- ----------------------- SmartphoneNavigation ----------------------- -->
        <transition
            appear
            name="smartphone-navigation"
            v-if="showSidebar"
        >
            <div class="fixed top-0 inset-x-0 p-2 md:hidden z-50">
                <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                    <div class="pt-5 pb-6 px-5">
                        <div class="flex items-center justify-between">
                            <div>
                                <p class="text-lg font-semibold">Markus Holzbach</p>
                            </div>
                            <div class="-mr-2">
                                <button
                                    @click="showSidebar = false"
                                    type="button"
                                    class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                                >
                                    <span class="sr-only">Close menu</span>
                                    <svg
                                        class="h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="mt-6">
                            <nav class="grid gap-y-8">
                                <router-link
                                    to="/"
                                    class="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                                >
                                    <span
                                        class="ml-3 text-base font-medium text-gray-900"
                                        @click="showSidebar = false"
                                    >
                                        <span v-if="isGerman">Projekte</span>
                                        <span v-else>Project</span>
                                    </span>
                                </router-link>
                                <router-link
                                    to="/curriculum-vitae"
                                    class="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                                >
                                    <span
                                        class="ml-3 text-base font-medium text-gray-900"
                                        @click="showSidebar = false"
                                    >
                                        <span v-if="isGerman">Lebenslauf</span>
                                        <span v-else>CV</span>
                                    </span>
                                </router-link>
                                <router-link
                                    to="/imprint"
                                    class="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                                >
                                    <span
                                        class="ml-3 text-base font-medium text-gray-900"
                                        @click="showSidebar = false"
                                    >
                                        <span v-if="isGerman">Impressum</span>
                                        <span v-else>Imprint</span>
                                    </span>
                                </router-link>
                                <router-link
                                    to="/contact"
                                    class="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                                >
                                    <span
                                        class="ml-3 text-base font-medium text-gray-900"
                                        @click="showSidebar = false"
                                    >
                                        <span v-if="isGerman">Kontakt</span>
                                        <span v-else>Contact</span>
                                    </span>
                                </router-link>
                            </nav>
                        </div>
                    </div>
                    <div class="py-6 px-5 space-y-6">
                        <button
                            v-on:click="$emit('toggleLanguage')"
                            type="button"
                            class="w-full px-4 py-2 hover:bg-purple-700 bg-purple-500 text-gray-50 rounded-md text-base font-medium "
                        >
                            <span v-if="isGerman">English</span>
                            <span v-else>Deutsch</span>
                        </button>
                    </div>
                </div>
            </div>
        </transition>
        <!-- ----------------------- END SmartphoneNavigation ----------------------- -->

    </div>
</template>
<script>
export default {
    props: {
        isGerman: {
            type: Boolean,
            required: true,
        }
    },
    data ()
    {
        return {
            showSidebar: false,
        };
    },
    methods: {},
    created () { },
};
</script>
<style lang="css">
.smartphone-navigation-enter-active,
.smartphone-navigation-leave-active {
    transition: opacity 0.5s;
}
.smartphone-navigation-enter,
.smartphone-navigation-leave-to {
    opacity: 0;
}
</style>